/**
 * MesVisasCard — RP52-54 : « Mes visas » au tableau de bord (partenaire, entreprise).
 * Visas qui attendent mon avis (viseur) et visas que j'ai déposés, tous chantiers.
 * Endpoint : GET /api/me/visas. N'affiche rien s'il n'y a aucun visa.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Stamp, Warning } from '@phosphor-icons/react';
import { STATUT_VISA_COURT, STATUT_VISA_COULEUR, libellePiece, libelleDelai, dateFr } from './visasLibelles';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function MesVisasCard() {
  const [visas, setVisas] = useState([]);

  useEffect(() => {
    let annule = false;
    axios.get(`${API_URL}/api/me/visas`, { withCredentials: true })
      .then(({ data }) => { if (!annule) setVisas(Array.isArray(data) ? data : []); })
      .catch(() => { if (!annule) setVisas([]); });
    return () => { annule = true; };
  }, []);

  if (!visas.length) return null;
  const aViser = visas.filter((v) => v.a_viser_par_moi);
  const autres = visas.filter((v) => !v.a_viser_par_moi).slice(0, 8);

  const ligne = (v) => (
    <Link key={v.id} to={`/chantiers/${v.chantier_id}?tab=visas&visa=${v.id}`} className="block px-4 py-3 hover:bg-[#FAFAF9]">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-medium text-[#2C2C2C] truncate">{v.titre} — {libellePiece(v.nature, v.indice)}</p>
          <p className="text-xs text-[#6B6B6B]">{v.chantier_nom}{v.lot_code ? ` · ${v.lot_code}` : ''}</p>
        </div>
        <div className="flex flex-col items-end gap-1 flex-shrink-0">
          <span className={`text-[10px] uppercase font-semibold px-1.5 py-0.5 rounded ${STATUT_VISA_COULEUR[v.statut] || ''}`}>{STATUT_VISA_COURT[v.statut]}</span>
          {v.statut === 'a_viser' && (
            <span className={`text-xs ${v.en_retard ? 'text-[#8B3A3A] font-bold' : 'text-[#6B6B6B]'}`}>
              {v.en_retard && <Warning size={11} className="inline mr-0.5" />}{dateFr(v.date_limite)} · {libelleDelai(v)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );

  return (
    <div className="border border-[#E0E0DB] bg-white" data-testid="mes-visas">
      <div className="px-4 py-3 border-b border-[#E0E0DB] flex items-center gap-2">
        <Stamp size={16} className="text-[#1E3A5F]" />
        <h2 className="text-sm font-bold uppercase tracking-wider text-[#6B6B6B]">Mes visas</h2>
      </div>
      {aViser.length > 0 && (
        <>
          <p className="px-4 pt-3 text-xs font-semibold text-[#1E3A5F]">À viser ({aViser.length})</p>
          <div className="divide-y divide-[#E0E0DB]">{aViser.map(ligne)}</div>
        </>
      )}
      {autres.length > 0 && (
        <>
          {aViser.length > 0 && <p className="px-4 pt-3 text-xs font-semibold text-[#6B6B6B]">Autres visas</p>}
          <div className="divide-y divide-[#E0E0DB]">{autres.map(ligne)}</div>
        </>
      )}
    </div>
  );
}
